import { Clock, BadgePercent, Radar, MailCheck } from "lucide-react";
import { Reveal, ChapterHead } from "./Reveal";
import { BookingForm, CallPanel } from "./BookingForm";

const TRUST = [
  { icon: Clock, title: "24/7 Availability", text: "Midnight airport run or 5am start — dispatch never sleeps." },
  { icon: BadgePercent, title: "Zero Surge Pricing", text: "Real meters, fixed airport rates. Rain never changes the price." },
  { icon: Radar, title: "Live GPS Tracking", text: "Watch your cab approach from the moment it's assigned." },
  { icon: MailCheck, title: "Instant Email Receipt", text: "Booking confirmation and ride receipts land in your inbox." },
];

export const BookingSection = () => (
  <section id="book" className="relative py-24 sm:py-32 bg-ink-950/40">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <ChapterHead
        num="CHAPTER 04"
        kicker="Booking engine"
        title="Book a taxi now — online in 30 seconds or by phone"
      />

      <div className="grid lg:grid-cols-[1.25fr_0.75fr] gap-6 items-stretch">
        <Reveal>
          <div className="h-full bg-ink-800 border border-gold-400/20 rounded-3xl p-6 sm:p-10">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold-300 mb-1">
              Instant online booking
            </p>
            <h3 className="font-display text-2xl font-extrabold text-white mb-8">
              Book a local taxi near you instantly online
            </h3>
            <BookingForm variant="full" />
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="h-full flex flex-col gap-6">
            <div className="glass border border-gold-400/25 rounded-3xl p-6 sm:p-8 flex-1 flex flex-col justify-between gap-8">
              <div>
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold-300 mb-1">
                  Direct call dispatch
                </p>
                <h3 className="font-display text-2xl font-extrabold text-white">
                  Talk to a human. Now.
                </h3>
              </div>
              <CallPanel />
              <ul className="font-mono text-xs text-[#99A1B3] space-y-2.5">
                <li className="flex justify-between border-b border-gold-400/10 pb-2">
                  <span>HOURS</span><span className="text-white">24 / 7 / 365</span>
                </li>
                <li className="flex justify-between border-b border-gold-400/10 pb-2">
                  <span>CALL</span><span className="text-white">1300 582 485</span>
                </li>
                <li className="flex justify-between">
                  <span>EMAIL</span><span className="text-white">sydneyasaptaxis@gmail.com</span>
                </li>
              </ul>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-20">
        {TRUST.map((t, i) => (
          <Reveal key={t.title} delay={i * 0.07}>
            <div
              data-testid={`trust-card-${i + 1}`}
              className="h-full bg-ink-800/70 border border-gold-400/10 rounded-2xl p-6 transition-colors duration-300 hover:border-gold-400/35"
            >
              <t.icon size={22} className="text-gold-400 mb-4" strokeWidth={1.6} />
              <h4 className="font-display font-bold text-white text-base mb-2">{t.title}</h4>
              <p className="text-xs leading-relaxed text-[#99A1B3]">{t.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
